export default "__VITE_ASSET__BBh2LRmS__"